<template>
  <sui-accordion exclusive>
        <div v-for="(item, index) in bankAccountsList" :key="index" class="mb-20">
            <sui-accordion-title :active="index===0">
                <h4 class="ui blue header">
                    <sui-icon name="dropdown" /> {{ item.companyName }}
                </h4>
            </sui-accordion-title>
            <sui-accordion-content :active="index===0">
                <sui-list>
                    <a is="sui-list-item" v-for="account in item.accounts" :key="account.id">
                        <sui-checkbox :label="account.accountName" v-model="account.selected" />
                    </a>
                </sui-list>
            </sui-accordion-content>
        </div>
    </sui-accordion>
</template>

<script>
import UsersBankAccountsService from '@/services/UsersBankAccountsService'

export default {
    name: 'UserBankAccounts',
    props: ['user'],
    async beforeMount () {
        this.loader = this.$loading.show()
        this.getBankAccounts()
    },
    data () {
        return {
            bankAccountsList: [],
            loader: undefined
        }
    },
    methods: {
        async getBankAccounts () {
            try {
                let { data } = await UsersBankAccountsService.getAll({ active: true })

                this.bankAccountsList = this.getOrderedBankAccounts(data)
                this.setBankAccounts()
                this.loader.hide()
            } catch (error) {
                console.error(error)
                this.$swal({
                    title: error.message,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Volver al listado',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                })
            }
        },
        getOrderedBankAccounts (bankAccounts) {
            const orderedBankAccounts = []
            const companiesIds = [...new Set(bankAccounts.map((item) => item.companyId))]

            for (let companyId of companiesIds) {
                let companyAccounts = bankAccounts.filter(item => item.companyId === companyId).map(item => {
                    item.selected = false
                    return item
                })

                const companyName = bankAccounts.find(item => item.companyId === companyId)
                if (!companyName) continue

                orderedBankAccounts.push({
                    companyId, companyName: companyName.company.companyName, accounts: companyAccounts
                })
            }

            return orderedBankAccounts
        },
        setBankAccounts () {
            for (let company of this.bankAccountsList) {
                for (let bankAccount of company.accounts) {
                    if (this.user.bankAccounts.includes(bankAccount.id)) {
                        bankAccount.selected = true
                    }
                }
            }
        }
    },
    watch: {
        userBankAccountsToSave () {
            this.$emit('setUserBankAccounts', this.userBankAccountsToSave)
        }
    },
    computed: {
        userBankAccountsToSave () {
            let bankAccounts = []
            for (let company of this.bankAccountsList) {
                let childs = company.accounts.filter(m => m.selected).map(m => { return m.id })
                bankAccounts = bankAccounts.concat(childs)
            }
            return bankAccounts
        }
    }
}
</script>

<style>

</style>
